import { mobileBreakpoints } from "../theme/breakpoints";
import useCurrentBreakpoint from "./useCurrentBreakpoint";

export function useIsSmallScreen(): boolean {
  const currentBreakpoint = useCurrentBreakpoint();

  return mobileBreakpoints.includes(currentBreakpoint);
}
